import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'la_boutique';

const supportEmail = {
	[customerGroup]: 'la_boutique@smoothr.de',
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyAhTAHZ8fiLACOVP3I9nYYmK29c0IzGfBk',
		authDomain: 'enrique-tomas-ea8fe.firebaseapp.com',
		projectId: 'enrique-tomas-ea8fe',
		storageBucket: 'enrique-tomas-ea8fe.firebasestorage.app',
		messagingSenderId: '99222302132',
		appId: '1:99222302132:web:f765a17e38df42321c96e1',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBxctZyYOPXBxP8pv-IsX0F3y16TB3nCFU',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	allergens_link: '',
	hasRecommendations: true,
	...apiEnvironment,
	hjid: 5035140,
	merchantId: '',
	merchantGoogleId: '',
};
